import React, { FC } from "react";
import { Card, Typography, Button, Space, Popconfirm } from "antd";
import {
  ShoppingCartOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { PerfumeResponse } from "../../types/types";
import { ACCOUNT_ADMIN_EDIT } from "../../constants/routeConstants";
import { useSelector } from "react-redux";
import { selectUserFromUserState } from "../../redux-toolkit/user/user-selector";
import "./PerfumeCard.css";

const { Text } = Typography;

type PropsType = {
  perfume: PerfumeResponse;
  isAdminView?: boolean; // ✅ Only true for Admin List of Products
  onDelete?: (perfume: PerfumeResponse) => void;
};

const PerfumeCard: FC<PropsType> = ({
  perfume,
  isAdminView = false,
  onDelete,
}) => {
  const user = useSelector(selectUserFromUserState);
  const isAdmin = user?.roles?.includes("ADMIN");

  return (
    <div className="flipkart-card-container">
      <Link to={`/product/${perfume.id}`} className="flipkart-card-link">
        <Card hoverable className="flipkart-card" bodyStyle={{ padding: 10 }}>
          <div className="flipkart-img-box">
            <img src={perfume.filename} alt={perfume.perfumeTitle} />
            <div className="flipkart-rating">
              {perfume.perfumeRating.toFixed(1)} ★
            </div>
          </div>

          <Text className="flipkart-card-title" ellipsis>
            {perfume.perfumeTitle}
          </Text>
          <Text className="flipkart-card-brand" type="secondary">
            {perfume.brand}
          </Text>

          <div className="flipkart-card-price">
            <Text delete className="old-price">₹{perfume.price + 200}</Text>
            <Text strong className="new-price">₹{perfume.price}</Text>
          </div>
           <Text className="flipkart-card-brand" type="secondary">
            {perfume.minQuantity}
          </Text>

          <ShoppingCartOutlined className="flipkart-cart-icon" />
        </Card>
      </Link>

      {/* ✅ Admin-only Edit/Delete buttons (only in Admin View) */}
      {isAdmin && isAdminView && (
        <div className="admin-action-bar">
          <Space>
            <Link to={`${ACCOUNT_ADMIN_EDIT}/${perfume.id}`}>
              <Button
                icon={<EditOutlined />}
                size="small"
                type="primary"
                style={{ background: "#1677ff", borderColor: "#1677ff" }}
              >
                Edit
              </Button>
            </Link>

            <Popconfirm
              title="Delete this perfume?"
              onConfirm={() => onDelete?.(perfume)}
              okText="Yes"
              cancelText="No"
            >
              <Button icon={<DeleteOutlined />} size="small" danger>
                Delete
              </Button>
            </Popconfirm>
          </Space>
        </div>
      )}
    </div>
  );
};

export default PerfumeCard;
